import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import _ from 'lodash';

class Search extends Component {
  constructor(props){
    super(props);

    this.state = {
      term: ''
    }

    //bind with delay for typing
    this.searchWithDebounce = _.debounce((e,val) => {
      this.submitSearch(val);
    }, 500);
    this.submitSearch = this.submitSearch.bind(this);
    this.handleSearchFieldChange = this.handleSearchFieldChange.bind(this);
  }

  submitSearch(term) {
    if(term.length < 3) { return; }
    
    const product = 'wdelite';
    const url = encodeURI(`/search/${product}/${term}`);
    this.props.history.push(url);
    //this.setState({term: ''});
  }

  handleSearchFieldChange(e) {
    const term = e.target.value;
    this.setState({term: term});
    this.searchWithDebounce(e, term);
  }

  render(){
    return (
      <div id="search" className="search">
        <input 
          type="search" 
          placeholder="Search documentation..."
          maxLength="150"
          value={this.state.term} 
          onChange={ this.handleSearchFieldChange }
        />
      </div>
    );
  }
}

export default withRouter(Search);